export const GEOLOCATION_FETCH = 'GEOLOCATION_FETCH'
import {makeAnswer} from './chat'
import api from '../api'

function geoString({city, region}) {
  if (typeof city === 'string' && city.length > 0) {
    return typeof region === 'string' && region.length > 0
      ? `${city} (${region})`
      : city
  }
  return null
}

export function fetchGeolocation() {
  return (dispatch, getState) => {
    fetch('https://занять-денег.онлайн/api/v1/geolocation')
      .then(r => r.json())
      .then(info => {
        dispatch({type: GEOLOCATION_FETCH, info})
        const geo = geoString(info)
        if (geo) {
          api.answers.send(makeAnswer('geo', geo, getState()))
        }
      })
  }
}



// WEBPACK FOOTER //
// ./actions/geolocation.js